import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { AddEmailComponent } from 'src/app/dialog/add-email/add-email.component';
import { ChangeLanguageComponent } from 'src/app/dialog/change-language/change-language.component';
import { ChangeNameComponent } from 'src/app/dialog/change-name/change-name.component';
import { ChangePasswordComponent } from 'src/app/dialog/change-password/change-password.component';
import { ImageCropperComponent } from 'src/app/dialog/image-cropper/image-cropper.component';
// import { NewImageCropperComponent } from 'src/app/dialog/new-image-cropper/new-image-cropper.component';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { UserModel } from 'src/app/models/user';
import { DataService } from 'src/app/services/data.service';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { OrderSummaryServiceService } from 'src/app/services/order-summary-service.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-setting-home',
  templateUrl: './setting-home.component.html',
  styleUrls: ['./setting-home.component.css']
})
export class SettingHomeComponent implements OnInit {
  currentLang: string;
  availableLang: string[];
  currentUser: UserModel;
  constructor(
    private translate: TranslateService,
    private dialog: MatDialog,
    private user: UserService,
    private snackbar: MatSnackBar,
    private orderSummary: OrderSummaryServiceService,
    private utilityService: UtilityService,
    private data: DataService,
    private loadingService: LoadingService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.orderSummary.update();
    this.currentLang = this.utilityService.getLang();
    this.availableLang = this.utilityService.getAvailableLang();
  }
  private setLang(lang: string): void {
    this.utilityService.setLang(lang);
    this.currentLang = lang;
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }

  onImageCropped(event): void {
    console.log(event)
  }
  
  onAvatarChange(event): void {
    const file: File = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      this.loadingService._clearLoading();
      this.dialog.open(ImageCropperComponent, {
        width: '880px',
        disableClose: true,
        autoFocus: false,
        data: {
          image: e.target.result,
          isShow: false
        }
      })
      .afterClosed()
      .subscribe((canvas: HTMLCanvasElement) => {
        event.target.value = "";
        if (!canvas) return;
        this.loadingService._setLoading();
        const dataURI = canvas.toDataURL(file.type, 1);
        canvas.remove();
        const imageCropped = this.utilityService.b64toBlob(dataURI, file.type);
        this.user.uploadAvatar(imageCropped)
        .then(() => {
          this.user.getSelf().subscribe(response => {
            if (response.status != STATUS.SUCCESS) return;
            this.data.getUserImage();
            this.loadingService._clearLoading();
          })
        })
        .catch(() => {
          this.snackbar.openFromComponent(SnackbarMessageComponent, {
            data: {
              message: 'MSG.UPLOAD_PF_FAILED'
            },
            duration: 1500,
            panelClass: 'bg-warn'
          });
        });
        // console.log(imageCropped);
        // return;
        // canvas.toBlob(blob => {
        //   console.log(blob)
        //   this.user.uploadAvatar(blob)
        //   .then(() => {
        //     canvas.remove();
        //     this.user.getSelf().subscribe(response => {
        //       if (response.status != 1) return;
        //       this.user.setUser(response.data.user);
        //       this.data.getUserImage();
        //       this.loadingService._clearLoading();
        //     });
        //   })
        //   .catch(() => {
        //     this.snackbar.openFromComponent(SnackbarMessageComponent, {
        //       data: {
        //         message: 'MSG.UPLOAD_PF_FAILED'
        //       },
        //       duration: 1500,
        //       panelClass: 'bg-warn'
        //     });
        //   })
        // }, file.type, 1);
      })
    }
    this.loadingService._setLoading();
    reader.readAsDataURL(file);
  }
  onChangeName(): void {
    this.dialog.open(ChangeNameComponent, {
      width: '450px',
      disableClose: true,
      autoFocus: false
    })
    .afterClosed()
    .subscribe(response => {
      if (!response) return;
      this.snackbar.openFromComponent(SnackbarMessageComponent, {
        data: {
          message: 'MSG.UPDATE_SUCCESS'
        },
        panelClass: 'bg-accent',
        duration: 1000
      })
    })
  }

  addEmail(): void {
    this.dialog.open(AddEmailComponent, {
      width: '580px',
      disableClose: true,
      autoFocus: false
    })
    .afterClosed()
    .subscribe(response => {
      if (!response) return;
      this.snackbar.openFromComponent(SnackbarMessageComponent, {
        data: {
          message: 'MSG.UPDATE_SUCCESS'
        },
        panelClass: 'bg-accent',
        duration: 1000
      })
    })
  }
  onChangePassword(): void {
    this.dialog.open(ChangePasswordComponent, {
      width: '450px',
      disableClose: true,
      autoFocus: false
    }).afterClosed()
    .subscribe(response => {
      if (!response) return;
      this.snackbar.openFromComponent(SnackbarMessageComponent, {
        data: {
          message: 'MSG.UPDATE_SUCCESS'
        },
        panelClass: 'bg-accent',
        duration: 1000
      })
    })
  }

  onChangeLanguage() {
    this.dialog.open(ChangeLanguageComponent, {
      width: '600px',
      disableClose: true,
      autoFocus: false,
      data: {
        lang: this.currentLang
      }
    }).afterClosed()
    .subscribe(lang=> {
      this.setLang(lang);
      this.localStorageService.set(LocalStorage.LANG, lang)
    });
  }

  get self(): UserModel {
    return this.user.me || {} as UserModel;
  }
  get genders(): string[] {
    return this.utilityService.avalableGender;
  }
}
